<template>
  <div class="EditSchedule lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="EditSchedule-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="EditSchedule-main lxn-pos-rel">
      <div class="EditSchedule-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title1}}
          </template>
          <template v-slot:body>
            <div class="EditSchedule-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="EditSchedule-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="EditSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="EditSchedule-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="EditSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="EditSchedule-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="EditSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="EditSchedule-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="EditSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="EditSchedule-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="EditSchedule-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="ScheduleName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddSchedule_namePlaceHolder" inputType="text" />
            </div>
            <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" :disabled="true" />
            </div>
            <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text7}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetScheduleType" :dropDownContex="dropDownTargetScheduleType" :disabled="true" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title2}}
          </template>
          <template v-slot:body>
            <div v-if="targetScheduleType == 2" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="AddSchedule-wrapper-name-text lxn-w100 lxn-text">
              {{$store.getters.language.texts.AddSchedule_title4}}
            </div>  
            <div :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
              <div style="flex-grow: 1;">
                <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.AddSchedule_text3}}
                </div>
                <div class="lxn-w100 lxn-overflow-hidden">
                  <NumberInputSpinner :min="0" :max="23" :step="1" :integerOnly="true" v-model="hour" buttonClass="EditSchedule-commandDelay-button" :twoDigitsOnly="true" />
                </div>
              </div>
              <div style="flex-grow: 1;">
                <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.AddSchedule_text4}}
                </div>
                <div class="lxn-w100 lxn-overflow-hidden">
                  <NumberInputSpinner :min="0" :max="59" :step="1" :integerOnly="true" v-model="minute" buttonClass="EditSchedule-commandDelay-button" :twoDigitsOnly="true" />
                </div>
              </div>
            </div>
            <div v-if="targetScheduleType == 2" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="AddSchedule-wrapper-name-text lxn-w100 lxn-text">
              {{$store.getters.language.texts.AddSchedule_title5}}
            </div>
            <div v-if="targetScheduleType == 2" :class="$store.getters.language.directionClass" style="display:flex;flex-wrap: nowrap; justify-content: space-between; gap:10px">
              <div style="flex-grow: 1;">
                <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.AddSchedule_text3}}
                </div>
                <div class="lxn-w100 lxn-overflow-hidden">
                  <NumberInputSpinner :min="0" :max="23" :step="1" :integerOnly="true" v-model="endHour" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
                </div>
              </div>
              <div style="flex-grow: 1;">
                <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{$store.getters.language.texts.AddSchedule_text4}}
                </div>
                <div class="lxn-w100 lxn-overflow-hidden">
                  <NumberInputSpinner :min="0" :max="59" :step="1" :integerOnly="true" v-model="endMinute" buttonClass="AddSchedule-commandDelay-button" :twoDigitsOnly="true" />
                </div>
              </div>
            </div>
            <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text5}}
            </div>
            <div class="lxn-w100 lxn-overflow-hidden">
              <div @click="daySelected(6)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(6), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[6]}}
              </div>
              <div @click="daySelected(0)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(0), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[0]}}
              </div>
              <div @click="daySelected(1)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(1), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[1]}}
              </div>
              <div @click="daySelected(2)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(2), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[2]}}
              </div>
              <div @click="daySelected(3)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(3), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[3]}}
              </div>
              <div @click="daySelected(4)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(4), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[4]}}
              </div>
              <div @click="daySelected(5)" class="EditSchedule-days lxn-float-right lxn-border-round lxn-text-center lxn-cursor-pointer" :class="[repeatDaysSelected(5), $store.getters.language.font, $store.getters.language.directionClass]">
                {{$store.getters.language.texts.weekDaysShort[5]}}
              </div>
            </div>
            <div class="EditSchedule-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddSchedule_text6}}
            </div>
            <div class="EditSchedule-wrapper-nextOccurrence lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{nextOccurrence}}
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddSchedule_title3}}
          </template>
          <template v-slot:body>
            <CommandCreator v-model="generatedCommand" titleBgColor="#00AEEF" :multiHub="false" :outputsOnly="true" :noHubSelect="true" :hubIndex="targetHub" :showAutomations="targetScheduleType == 1" :showInputs="targetScheduleType == 2" :commandToLoad="{hubUUID: schedule.hubUUID, command: schedule.scheduleCommand}" />
          </template>
        </TitleBox>
      </div>
      <div class="EditSchedule-button lxn-margin-auto lxn-w100">
        <!-- //TODO: check if schedules are loaded and there exists a scene in target hub -->
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button}}
        </CustomButton>
      </div>
      <div class="EditSchedule-button lxn-margin-auto lxn-w100">
        <!-- //TODO: check if schedules are loaded and there exists a scene in target hub -->
        <CustomButton @click="deleteSchedule" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button3}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CommandCreator from '@/components/CommandCreator.vue'
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import CustomInput from '@/components/CustomInput.vue'
import DropDown from '@/components/DropDown.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import NODE7 from '@/statics/devices/Node7/header.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import moment from 'jalali-moment'
import Vue from 'vue'

var messaging = new Messaging(new Logger(false));

export default {
  name: 'EditSchedule',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    DropDown,
    NumberInputSpinner,
    CommandCreator
  },
  data: function () {
    var schedule = this.$store.state.schedules[this.$route.params.scheduleIndex];
    var targetHub = this.$store.getters.getHubByUUID(schedule.hubUUID).index;
    var targetScheduleType = schedule.type;
    // if(schedule.type == messaging.UPLINK_PACKET_SET_EVENT_MASKS){
    //   targetScheduleType = 1;
    // }
    return {
      schedule: schedule,
      hour: 0,
      minute: 0,
      ScheduleName: '',
      input1State: '',
      activeBoxIndex: 0,
      targetHub: targetHub,
      repeatDays: [false, false, false, false, false, false, false],
      generatedCommand: [],
      targetScheduleType: targetScheduleType,
      endHour: 0,
      endMinute: 0,
      secondarySchedule: undefined
    }
  },
  mounted: function () {
    this.ScheduleName = this.schedule.name;
    this.activeBoxIndex = this.schedule.color;

    var scheduleDateTimeStamp = this.schedule.timeEvent.dateStamp * 86400000 + this.schedule.timeEvent.timeStamp;
    var dateObject = new Date(scheduleDateTimeStamp);
    this.hour = dateObject.getHours();
    this.minute = dateObject.getMinutes();
    
    var weekDaysOffset = 0;
    var timeZoneOffset = new Date().getTimezoneOffset();

    var timeStampInMinutes = this.hour*60 + this.minute + timeZoneOffset;

    if(timeStampInMinutes < 0){
      weekDaysOffset = 1;
    }else if(timeStampInMinutes >= 24*60){
      weekDaysOffset = -1;
    }

    if((this.schedule.timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL) == 0){
      for(var i = 0; i < 7; i++){
        if((this.schedule.timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_WEEKDAYS[i]) != 0){
          var weekDayWithOffset = (((i + weekDaysOffset) % 7) + 7) % 7;
          this.repeatDays[weekDayWithOffset] = true;
        }
      }
    }

    let primaryScheduleId = this.schedule.eventIdToWatch & 0xFF
    let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
    this.secondarySchedule = this.$store.getters.getScheduleForHubByEventId(this.schedule.hubUUID, secondaryScheduleEventId);  
    
    scheduleDateTimeStamp = this.secondarySchedule.timeEvent.dateStamp * 86400000 + this.secondarySchedule.timeEvent.timeStamp;
    dateObject = new Date(scheduleDateTimeStamp);
    this.endHour = dateObject.getHours();
    this.endMinute = dateObject.getMinutes();

  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "EditSchedules-TargetHubs",
        title: this.$store.getters.language.texts.AddSchedule_text2,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
    dropDownTargetScheduleType: function () {
      var dropDownTargetScheduleType = {
        name: "AddSchedules-TargetScheduleType",
        title: this.$store.getters.language.texts.AddSchedule_text7,
        selectedIndex: this.targetScheduleType,
        data: [
          {
            name: this.$store.getters.language.texts.AddSchedule_text8,
            icon: "lamp",
          },
          {
            name: this.$store.getters.language.texts.AddSchedule_text9,
            icon: "auto",
          },
          {
            name: this.$store.getters.language.texts.AddSchedule_text10,
            icon: "notifs",
          }
        ]
      };
      return dropDownTargetScheduleType;
    },
    nextOccurrence: function () {
      if(this.schedule.active){
        var dateStamp = this.schedule.timeEvent.dateStamp;
        var timeStamp = this.schedule.timeEvent.timeStamp;
        var scheduleDateTimeStamp = dateStamp * 86400000 + timeStamp;

        if(this.$store.state.language == 'fa'){
          var dateObject = moment(scheduleDateTimeStamp).locale('fa');
          return dateObject.format("ddd, Do MMMM YYYY, h:mm a");
        }else{
          dateObject = new Date(scheduleDateTimeStamp);
          return dateObject.toLocaleString();
        }
      }else{
        return "-"
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    repeatDaysSelected: function (index) {
      if(this.repeatDays[index] == true){
        return 'active';
      }else{
        return '';
      }
    },
    daySelected: function (index) {
      var newVal = !this.repeatDays[index];
      Vue.set(this.repeatDays, index, newVal);
    },
    generateNodeActions: function (nodeActions) {
      var generatedNodeActions = [];
      var typeOfAction = 0;
      var valueOfChange = 0;

      for(var i = 0; i < nodeActions.length; i++){
        var isNodeNew = true;
        if(nodeActions[i].outputType != "IrDevice"){
          if(nodeActions[i].state == 'on'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 1;
          }else if(nodeActions[i].state == 'off'){
            typeOfAction = CONFIGS.ACTION_TYPE_SET;
            valueOfChange = 0;
          }
        }else{
          var deviceType = nodeActions[i].outputSettings.deviceType;
          var brand = nodeActions[i].outputSettings.brand;
          var model = nodeActions[i].outputSettings.model;
          var irDevice = NODE7.devices[deviceType].brands[brand].devices[model];

          valueOfChange = messaging.utility.arrayTo128(irDevice.commands[nodeActions[i].state.targetCommandIndex].command);
          typeOfAction = CONFIGS.ACTION_TYPE_SET;
        }
        var action = {
          parameterId: nodeActions[i].parameterId,
          valueOfChange: valueOfChange,
          typeOfAction: typeOfAction,
          timeDelay: nodeActions[i].timeDelay,
        }

        for(var j = 0; j < generatedNodeActions.length; j++){
          if(generatedNodeActions[j].nodeUUID == nodeActions[i].nodeUUID){
            generatedNodeActions[j].actions.push(action);
            isNodeNew = false;
            break;
          }
        }
        if(isNodeNew){
          generatedNodeActions.push(
            {
              nodeUUID: nodeActions[i].nodeUUID,
              actions: [action]
            }
          );
        }
      }
      return generatedNodeActions;
    },
    calculateDateTimeStamp: function (hour, minute) {
      var currentEpochTime = Date.now();

      var targetDateStamp = Math.floor(currentEpochTime / 86400000);
      var targetTimeStamp = 0;

      var localDateObject = new Date();
      var repeatMask = 0;

      var anyDaysSelected = false;
      for(var i = 0; i < this.repeatDays.length; i++){
        if(this.repeatDays[i] == true){
          anyDaysSelected = true;
        }
      }
      
      if(!anyDaysSelected){
        var userSelectedLocalTimeStamp = (hour*60 + minute) * 60000;
        var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
        var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
        if(timeStampDiff < 0){
          timeStampDiff += 86400000;
        }
        var userSelectedDateTimeStamp = currentEpochTime + timeStampDiff;
        targetDateStamp = Math.floor(userSelectedDateTimeStamp / 86400000);
        targetTimeStamp = userSelectedDateTimeStamp % 86400000;
        repeatMask = CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL;
        // console.log()
      }else{
        var weekDaysOffset = 0;
        var timeZoneOffset = localDateObject.getTimezoneOffset();

        var timeStampInMinutes = hour*60 + minute + timeZoneOffset;

        if(timeStampInMinutes < 0){
          timeStampInMinutes += 24*60;
          weekDaysOffset = -1;
        }else if(timeStampInMinutes >= 24*60){
          timeStampInMinutes -= 24*60;
          weekDaysOffset = 1;
        }
        targetTimeStamp = timeStampInMinutes*60000;

        for(i = 0; i < this.repeatDays.length; i++){
          if(this.repeatDays[i] == true){
            //unsigned mod implementation in js:
            var weekDayWithOffset = (((i + weekDaysOffset) % 7) + 7) % 7;
            repeatMask |= CONFIGS.SCHEDULE_REPEAT_MASK_WEEKDAYS[weekDayWithOffset];
          }
        }
      }
      return {
        repeatMask:repeatMask,
        resultDateStamp: targetDateStamp,
        resultTimeStamp: targetTimeStamp 
      }
    },
    saveChanges: async function () {
      this.input1State = '';
      if(this.ScheduleName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddSchedule_alert1);
      }else if(this.generatedCommand.length == 0){
        alert(this.$store.getters.language.texts.AddSchedule_alert5);
      }else{
        var hub = this.$store.state.hubs[this.targetHub];
        var messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });

        let { repeatMask, resultDateStamp, resultTimeStamp} = this.calculateDateTimeStamp(this.hour, this.minute);
        // let reversedMaskslist = JSON.parse(JSON.stringify(this.generatedCommand[0].maskList));
        let targetDateStamp = resultDateStamp;
        let targetTimeStamp = resultTimeStamp;
        ({repeatMask, resultDateStamp, resultTimeStamp} = this.calculateDateTimeStamp(this.endHour, this.endMinute));   
        let endTargetDateStamp = resultDateStamp;
        let endTargetTimeStamp = resultTimeStamp;
        this.$store.commit('setAppBusy', true);

        var newEventIdToWatch = this.schedule.eventIdToWatch;
        var instructionList = [];

        var scheduleCommand = [];
        var secondScheduleCommand = []; // in case of this.targetScheduleType == 2 the second schedule command will be used to reverse the first maskslist 
        if(this.targetScheduleType == 1 || this.targetScheduleType == 2){
          scheduleCommand = messagingHook.createHubMessage(
            {
              messageType: messagingHook.UPLINK_PACKET_SET_EVENT_MASKS,
              bodyContent: {
                maskList: this.generatedCommand[0].maskList
              },
            }
          ).serializedMessageArray.splice(19);
          if (this.targetScheduleType == 2) {
              let reversedMaskslist = JSON.parse(JSON.stringify(this.generatedCommand[0].maskList));
              reversedMaskslist = reversedMaskslist.map(mask => {
                mask.isMasked = !mask.isMasked;
                return mask
              })

              secondScheduleCommand = messagingHook.createHubMessage(
                {
                  messageType: messagingHook.UPLINK_PACKET_SET_EVENT_MASKS,
                  bodyContent: {
                    maskList: reversedMaskslist
                  },
                }
              ).serializedMessageArray.splice(19);
            }
        }else{
          var nodeActions = this.generateNodeActions(this.generatedCommand[0].actions);
          messagingHook.setParametersOfNodesSerializer(scheduleCommand, {nodeActions: nodeActions});
        }
        
        try {
          if(JSON.stringify(scheduleCommand) != JSON.stringify(this.schedule.scheduleCommand) || this.secondarySchedule !== undefined){
            if(this.targetScheduleType == 1){
              
              var imitatorsList = await this.$store.dispatch('getUplinkImitators', {messagingHook: messagingHook,hubUUID: hub.uuid,});
              imitatorsList = imitatorsList.body.bodyContent.imitatorsList;
              var newImitatorsList = [];
              if (JSON.stringify(scheduleCommand) != JSON.stringify(this.schedule.scheduleCommand)) {
                for(let i = 0; i < imitatorsList.length; i++){
                  if(imitatorsList[i].eventIdToWatch !== newEventIdToWatch){
                    newImitatorsList.push(imitatorsList[i]);
                  }
                }
                newImitatorsList.push({
                  eventIdToWatch: newEventIdToWatch,
                  commandLength: scheduleCommand.length,
                  commandToSend: scheduleCommand,
                })
              }
              if (JSON.stringify(secondScheduleCommand) != JSON.stringify(this.secondarySchedule.scheduleCommand)) {
                newImitatorsList.push({
                  eventIdToWatch: this.secondarySchedule.eventIdToWatch,
                  commandLength: secondScheduleCommand.length,
                  commandToSend: secondScheduleCommand,
                })
              }
              if (newImitatorsList != 0) {
                await this.$store.dispatch('setUplinkImitator', {
                  messagingHook: messagingHook,
                  hubUUID: hub.uuid,
                  imitatorsList: newImitatorsList,
                })
              }                 
            }else{
              instructionList.push({
                eventIdToWatch: newEventIdToWatch,
                commandLength: scheduleCommand.length,
                commandToSend: scheduleCommand,
              });
              await this.$store.dispatch('modifyHubInstructions', {
                messagingHook: messagingHook,
                hubUUID: hub.uuid,
                instructions: instructionList,
              });
            }
          }
          var scheduleChanged = false;
          if( Math.abs(this.schedule.timeEvent.timeStamp - targetTimeStamp) > 999 || this.schedule.timeEvent.repeatMask != repeatMask){
            scheduleChanged = true;
          }else if(this.schedule.timeEvent.dateStamp != targetDateStamp && repeatMask == CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL){
            scheduleChanged = true;
          }
          if( Math.abs(this.secondarySchedule.timeEvent.timeStamp - endTargetTimeStamp) > 999 || this.secondarySchedule.timeEvent.repeatMask != repeatMask){
            scheduleChanged = true;
          }else if(this.secondarySchedule.timeEvent.dateStamp != endTargetDateStamp && repeatMask == CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL){
            scheduleChanged = true;
          }
          if(scheduleChanged){
            var schedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
            schedulesList = schedulesList.body.bodyContent.schedulesList;
            var foundSchedule = schedulesList.find((schedule, scheduleIndex) => {
              if(schedule.eventId == this.schedule.eventIdToWatch){
                schedulesList[scheduleIndex].timeEvent = {
                  dateStamp: targetDateStamp,
                  timeStamp: targetTimeStamp,
                  repeatMask: repeatMask,
                }
                return true;
              }
              return false;
            })
            if(!foundSchedule){
              schedulesList.push({
                timeEvent: {
                  dateStamp: targetDateStamp,
                  timeStamp: targetTimeStamp,
                  repeatMask: repeatMask,
                },
                eventId: newEventIdToWatch,
              });
            }
            if (this.secondarySchedule !== undefined){
              foundSchedule = schedulesList.find((schedule, scheduleIndex) => {
              if(schedule.eventId == this.secondarySchedule.eventIdToWatch){
                schedulesList[scheduleIndex].timeEvent = {
                  dateStamp: endTargetDateStamp,
                  timeStamp: endTargetTimeStamp,
                  repeatMask: repeatMask,
                }
                return true;
              }
              return false;
              })
              if(!foundSchedule){
                schedulesList.push({
                  timeEvent: {
                    dateStamp: endTargetDateStamp,
                    timeStamp: endTargetTimeStamp,
                    repeatMask: repeatMask,
                  },
                  eventId: this.secondarySchedule.eventIdToWatch,
                });
              }
            }
            await this.$store.dispatch('setHubSchedules', {
              messagingHook: messagingHook,
              hubUUID: hub.uuid,
              bodyContent: {
                schedulesList: schedulesList,
              }
            })
            this.$store.commit('updateScheduleTimeEvent', {
              scheduleIndex: this.$route.params.scheduleIndex,
              timeEvent: {
                dateStamp: targetDateStamp,
                timeStamp: targetTimeStamp,
                repeatMask: repeatMask,
              }
            })
            if (this.secondarySchedule !== undefined){
              this.$store.commit('updateScheduleTimeEvent', {
                scheduleIndex: this.secondarySchedule.index,
                timeEvent: {
                  dateStamp: endTargetDateStamp,
                  timeStamp: endTargetTimeStamp,
                  repeatMask: repeatMask,
                }
              })
            }
          }
          this.$store.commit('updateScheduleNameColor', {
            scheduleIndex: this.$route.params.scheduleIndex,
            name: this.ScheduleName,
            color: this.activeBoxIndex,
          });
          this.$store.commit('updateScheduleCommand', {
            scheduleIndex: this.$route.params.scheduleIndex,
            scheduleCommand: scheduleCommand,
          });
          if (this.secondarySchedule !== undefined){
            this.$store.commit('updateScheduleCommand', {
            scheduleIndex: this.secondarySchedule.index,
            scheduleCommand: secondScheduleCommand,
          });
          }
          this.$store.commit('saveState');
          this.$router.push('/schedules');
          this.$store.commit('setAppBusy', false)
        }
        catch (response) {
          console.log(response);
          if(response.rejectCode == 2){
            this.$router.push('/SettingsHubError');
            this.$store.commit('setHubStatus', {
              hubIndex: response.hubIndex,
              connectionStatus: {
                local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              },
            });
          }else{
            this.$router.push('/SettingsHubError');
          }
          this.$store.commit('setAppBusy', false);
        }
      }
    },
    deleteSchedule: function () {
      this.$router.push('/deleteSchedule/' + this.schedule.hubUUID + '/' + this.schedule.eventIdToWatch);
    },
  }
}
</script>

<style>
  .EditSchedule-topCurve-wrapper {
    height: 200px;
  }
  .EditSchedule-main {
    z-index: 2;
  }
  .EditSchedule-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .EditSchedule-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .EditSchedule-wrapper-colors {
    height: 50px;
  }
  .EditSchedule-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .EditSchedule-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .EditSchedule-color.active .EditSchedule-selectedColor {
    opacity: 1;
  }
  .EditSchedule-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .EditSchedule-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSchedule-wrapper-name-text:first-child {
    height: 30px;
    padding-top: 0;
  }
  .EditSchedule-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .EditSchedule-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .EditSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditSchedule-commandDelay-button:hover {
    opacity: 0.5;
  }
  .EditSchedule-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .EditSchedule-todayOnly {
    display: table;
    padding-left: 20px;
    padding-right: 20px;
    line-height: 40px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .EditSchedule-todayOnly.active {
    background-color: #1EA5DE;
  }
  .EditSchedule-days {
    width: calc(100% / 7 - 4px);
    height: 40px;
    margin-right: 2px;
    margin-left: 2px;
    line-height: 40px;
    background-color: #53636C;
    color: #FFFFFF;
  }
  .EditSchedule-days.active {
    background-color: #1EA5DE;
  }
</style>
